import { WorkspaceActions } from "../reducers/workspaces";

export const {
  selectWorkspace,
  refreshWorkspace,
  refreshWorkspaces,
  refreshWorkspaceResources,
  deleteWorkspace,
  updateWorkspace,
  resourceAdded,
} = WorkspaceActions;
